import { PositionsTable } from "@/routes/processes/[processId]/htz/offers/[offerId]/positions/_components/positions-table";

export function PositionsRoute() {
  return <PositionsTable />;
}
